




import Vue from 'vue'
import {mapActions} from 'vuex'

export default Vue.extend({
    data: () => ({
        fbSignInParams: {
            scope: 'email',
            return_scopes: true
        }
    }),
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('auth', ['onFacebookSignInSuccess', 'onFacebookSignInError'])
    }
})
